interface Rule {
  key: string;
  exactValue?: string;
  matcher?: RegExp;
}

export function getSelected(
  mapping: Rule[],
  value: string,
  defaultKey = ""
): string {
  for (const rule of mapping) {
    if (rule.exactValue) {
      if (rule.exactValue === value) {
        return rule.key;
      }
    } else {
      if (rule.matcher?.test(value)) {
        return rule.key;
      }
    }
  }

  return defaultKey;
}
